export default __webpack_public_path__ + "static/media/mixkit-games-worldbeat-466.fbb1a187.mp3";